module.exports = __webpack_public_path__ + "static/media/enroll.02777dc5.gif";